var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isCnpjValid } from '../ValidationUtils';
import { isValidCnpj } from '../documentoValidators';
export var handleValidCnpj = function (_a) {
    var _b, _c, _d;
    var _e;
    var event = _a.event, fieldErrorChange = _a.fieldErrorChange, fieldsErrors = _a.fieldsErrors, formData = _a.formData, onChange = _a.onChange, setCnpjValid = _a.setCnpjValid, _f = _a.fieldError, fieldError = _f === void 0 ? "cnpjError" : _f;
    var cnpj = (_e = event === null || event === void 0 ? void 0 : event.target) === null || _e === void 0 ? void 0 : _e.value;
    onChange(__assign(__assign({}, formData), { cnpj: cnpj ? cnpj.replace(/[^0-9A-Za-z]/g, '').toUpperCase() : cnpj }));
    var valid = cnpj && isCnpjValid(cnpj);
    if (!valid) {
        fieldErrorChange(__assign(__assign({}, fieldsErrors), (_b = {}, _b["".concat(fieldError)] = 'CNPJ inválido. Deve conter 14 dígitos.', _b)));
        setCnpjValid === null || setCnpjValid === void 0 ? void 0 : setCnpjValid(false);
        return false;
    }
    if (!isValidCnpj(cnpj)) {
        fieldErrorChange(__assign(__assign({}, fieldsErrors), (_c = {}, _c["".concat(fieldError)] = 'CNPJ inválido', _c)));
        setCnpjValid === null || setCnpjValid === void 0 ? void 0 : setCnpjValid(false);
        return false;
    }
    fieldErrorChange(__assign(__assign({}, fieldsErrors), (_d = {}, _d["".concat(fieldError)] = '', _d)));
    setCnpjValid === null || setCnpjValid === void 0 ? void 0 : setCnpjValid(true);
    return true;
};
